import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, App as AntdApp } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import Routes from 'routes/Routes';
import { CaptchaProvider } from 'components';

import useTheme from 'hooks/common/useTheme';
import useLocalStorageField from 'hooks/common/useLocalStorageField';

import accessTokenChangedCallback from 'utils/auth/accessTokenChangedCallback';

import { StorageKey } from 'constants/localStorage';

import 'assets/styles/common.scss';

const queryClient = new QueryClient();

function App() {
  const { themeConfig, initTheme } = useTheme();

  useLocalStorageField(StorageKey.ACCESS_TOKEN, accessTokenChangedCallback);

  useEffect(() => {
    initTheme();
  }, [initTheme]);

  return (
    <CaptchaProvider>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider theme={themeConfig}>
          <BrowserRouter>
            <AntdApp>
              <Routes />
            </AntdApp>
          </BrowserRouter>
        </ConfigProvider>
      </QueryClientProvider>
    </CaptchaProvider>
  );
}

export default App;
